import dayjs from '#dayjs'

import { createSharedComposable } from '#imports'

export const useDayjs = createSharedComposable(() => {
    return dayjs
})
